import { render, staticRenderFns } from "./RawMaterials.vue?vue&type=template&id=12adc5be"
import script from "./RawMaterials.vue?vue&type=script&lang=js"
export * from "./RawMaterials.vue?vue&type=script&lang=js"
import style0 from "./RawMaterials.vue?vue&type=style&index=0&id=12adc5be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports